import {
  takeLatest, call, put
} from 'redux-saga/effects';
import {
  LOAD_MONITORS_REQUEST,
  LOAD_MONITORS_SUCCESS,
  LOAD_MONITORS_ERROR
} from '../actions/index';

import $dataRepo from 'dataRepository';

// watcher saga: watches for actions dispatched to the store, starts worker saga
export default function* rootSaga() {
  yield takeLatest(LOAD_MONITORS_REQUEST, fetchMonitors);
}

// worker sagas: makes the api call when watcher saga sees the action
function* fetchMonitors() {
  try {
    const loadedMonitors = yield call($dataRepo.fetchMonitorsData);

    // success, store the content
    yield put({ type: LOAD_MONITORS_SUCCESS, loadedMonitors });

  } catch (error) {
    // error, reset content
    yield put({ type: LOAD_MONITORS_ERROR, error });
  }
}
